export enum AbTastyCampaignId {
  ONBOARDING_FLOW = import.meta.env.VITE_CAMPAIGN_ID_ONBOARDING_FLOW,
}
